import { decryptData, encryptData } from "config/config";
import { instance as axios, setMultiPartHeader } from "config/axiosInstance";
import { isLoggedIn } from "utils";


export const getStateTestimonials = async (data) => {
  return decryptData(
    await axios.get(
      `/state-wise-testimonials?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const addCityTestimonial = async (data) => {
  return decryptData(
    await axios.post(`/state-wise-testimonials-create`, data, setMultiPartHeader())
  );
};

export const updateCityTestimonial = async (data) => {
  return decryptData(
    await axios.post(`/state-wise-testimonials-edit`, data, setMultiPartHeader())
  );
};

export const deleteCityTestimonial = async (data) => {
  return decryptData(
    await axios.get(
      `/state-wise-testimonials-delete?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const updateCityTestimonialStatus = async (data) => {
  return decryptData(
    await axios.get(
      `/state-wise-testimonials-status?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};

export const getSingleCityTestimonialById = async (data) => {
  return decryptData(
    await axios.get(
      `/state-wise-testimonials-view?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getCityDropdown = async (data) => {
  return decryptData(
    await axios.get(
      `/dropdown-state-wise-centers?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};
export const getCenters = async (data) => {
  return decryptData(
    await axios.get(
      `/centers?reqData=${encryptData({
        ...data,
        access_token: isLoggedIn(),
      })}`
    )
  );
};